<template>
  <div class="container-fluid h-100">
    <div class="content_register" id="content1-register">
      <div
        class="row justify-content-center justify-content-sm-center justify-content-md-center justify-content-lg-center justify-content-xl-center align-items-center h-100"
      >
        <!-- Texto que va sobre la imagen -->
        <div id="content_info" class="col-12 col-md-12 col-lg-6 col-xl-5 col-sm-12">
          <!-- Título -->
          <h1 class="club">
            ¡HAZ TU REGISTRO DE <br> FORMA SENCILLA AQUÍ Y
          </h1>
          <hr class="white_line">
          <h1 class="content_title"><span class="obten">OBTÉN </span><span class="points">{{ cantPoints > 0 ? cantPoints : 20 }} PUNTOS!</span></h1>
          <hr class="white_line">
          <br>
          <h2 class="description">
            <strong>Disfruta de un catálogo de accesorios <br>
            moteros, descuentos con nuestros aliados, <br>
            el Havoblog y todos los beneficios que <br>
            te trae el Havoline Motoclub</strong>
          </h2>

          <h2 class="description_mobile">
            <strong>Disfruta de un catálogo de accesorios 
            moteros, descuentos con nuestros aliados, 
            el Havoblog y todos los beneficios que 
            te trae el Havoline Motoclub</strong>
          </h2>
          <div>
            <h3 class="info_btn_google">Regístrate mediante el formulario, <br>o también usando el botón de Google</h3>

            <div class="button_google">
              <button
                :disabled="disableLoadingGoogle"
                type="button"
                @click="registerGoogle()"
                class="btn btn-light btn-sm btn-block btn-register"
                id="btn-register-id"
              >
                <span
                  v-if="disableLoadingGoogle"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>
                  <img alt="Google" src="@/assets/icon/google-24px.png"/>
                </template>
              </button>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-6 col-xl-7 col-sm-12">
          <div class="row p-row mt-3">
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12 small-info">
              <!-- <small>Recuerda que los datos marcados con (*) son obligatorios</small> -->
              <h3 class="complet_your_form"><strong>¡Completa tu fomulario <br>y únete al Motoclub!</strong></h3>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                    v-model="form.documentType"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.documentType }"
                    id="exampleFormControlSelect1"
                    placeholder="Tipo de documento *"
                  >
                    <option value="0" disabled selected
                      >Tipo de documento *</option
                    >
                    <option
                      v-for="(item, i) in listTypeDocuments"
                      :key="'td' + i"
                      :value="item.id"
                      class="color-option"
                      >{{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.documentType"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentType }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    v-model="form.documentNumber"
                    type="text"
                    class="form-control color-input"
                    :class="{ 'is-danger': errors.documentNumber }"
                    aria-label="document"
                    placeholder="Número de documento * "
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.documentNumber"
                  class="text-danger float-left small error-danger"
                  >{{ errors.documentNumber }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.name }"
                    v-model="form.name"
                    type="text"
                    class="form-control color-input"
                    aria-label="name"
                    placeholder="Nombres *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.name"
                  class="text-danger float-left small error-danger"
                  >{{ errors.name }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.lastName }"
                    v-model="form.lastName"
                    type="text"
                    class="form-control color-input"
                    aria-label="lastName"
                    placeholder="Apellidos *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.lastName"
                  class="text-danger float-left small error-danger"
                  >{{ errors.lastName }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                    v-model="form.state"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.state }"
                    id="exampleFormControlSelect1"
                  >
                    <option disabled value="0" selected>Departamento *</option>
                    <option
                      v-for="(item, i) in listDocuments"
                      :value="item.id"
                      class=" color-option"
                      :key="'st' + i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.state"
                  class="text-danger float-left small error-danger"
                  >{{ errors.state }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <select
                    v-model="form.cityId"
                    :disabled="showCities"
                    class="form-control color-input select-input"
                    :class="{ 'is-danger': errors.cityId }"
                    id="exampleFormControlSelect1"
                  >
                    <option value="0" disabled selected>Ciudad *</option>
                    <option
                      v-for="(item, i) in listCities"
                      :key="'ci' + i"
                      :value="item.id"
                      class=" color-option"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
                <span
                  v-if="errors.cityId"
                  class="text-danger float-left small error-danger"
                  >{{ errors.cityId }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.phone }"
                    type="text"
                    v-model="form.phone"
                    class="form-control color-input"
                    aria-label="phone"
                    placeholder="Teléfono *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.phone"
                  class="text-danger float-left small error-danger"
                  >{{ errors.phone }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.email }"
                    v-model="form.email"
                    type="text"
                    class="form-control color-input"
                    aria-label="email"
                    placeholder="email *"
                    aria-describedby="basic-addon1"
                  />
                </div>
                <span
                  v-if="errors.email"
                  class="text-danger float-left small error-danger"
                  >{{ errors.email }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.birthdate }"
                    type="text"
                    v-model="form.birthdate"
                    class="form-control color-input"
                    placeholder="fecha de nacimiento *"
                    :min="minDate()"
                    :max="maxDate()"
                    onfocus="(this.type='date')"
                  />
                </div>
                <span
                  v-if="errors.birthdate"
                  class="text-danger float-left small error-danger"
                  >{{ errors.birthdate }}</span
                >
              </div>
            </div>
            <div
              class="col-12 col-md-12 col-lg-12 col-xl-12 col-sm-12"
              style="text-align: left;"
            >
              <label class="password-text"
                >Crea una nueva contraseña para ingresar al club</label
              >
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.pass }"
                    v-model="form.pass"
                    type="password"
                    ref="password"
                    class="form-control color-input"
                    aria-label="password"
                    placeholder="Contraseña *"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(1)" class="eye_pass">
                    <span id="pass1" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.pass"
                  class="text-danger float-left small error-danger"
                  >{{ errors.pass }}</span
                >
              </div>
            </div>
            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <div class="form-group">
                <div class="input-group mb-3">
                  <input
                    :class="{ 'is-danger': errors.passCon }"
                    v-model="form.passCon"
                    type="password"
                    ref="confirm_password"
                    class="form-control color-input"
                    aria-label="passwordC"
                    placeholder="Confirmar contraseña *"
                    aria-describedby="basic-addon1"
                  />
                  <div @click="showPass(2)" class="eye_pass">
                    <span id="pass2" class="fa-regular fa-eye-slash"></span>
                  </div>
                </div>
                <span
                  v-if="errors.passCon"
                  class="text-danger float-left small error-danger"
                  >{{ errors.passCon }}</span
                >
              </div>
            </div>

            <div class="col-12 col-md-12 col-lg-10 col-xl-10 col-sm-12">
              <table class="mb-2 table-register">
                <caption class="visually-hidden">TyC</caption>
                <tr hidden>
                  <th id="au-1">Acción</th>
                  <th id="au-2">Texto</th>
                </tr>
                <tr>
                  <td>
                    <input
                      :class="{ 'is-danger': errors.check }"
                      v-model="form.check"
                      style="cursor: pointer"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    <a class="condiciones" :href="file" target="_blank"
                      ><label> Acepta términos y condiciones *</label></a
                    >
                    <br />
                    <span
                      v-if="errors.check"
                      class=" text-danger float-left small error-danger "
                      style="padding-top: 11px;"
                      >{{ errors.check }}</span
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <input
                      v-model="form.checkMail"
                      type="checkbox"
                      name="checkbox"
                      id="checkbox1"
                    />
                  </td>
                  <td class="pl-3" style="text-align: left">
                    Me gustaría recibir noticias sobre productos y servicios de
                    Havoline Motoclub Te Cubre a través de e-mail y SMS.
                  </td>
                </tr>
              </table>

              <button
                :disabled="disableLoading"
                type="button"
                @click="registerUser()"
                class="btn btn-danger btn-sm btn-block btn-register"
                id="btn-register-id"
              >
                <span
                  v-if="disableLoading"
                  class="spinner-border spinner-border-md"
                  role="status"
                  aria-hidden="true"
                ></span>
                <template v-else>Regístrarme</template>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";

export default {
  name: "landingRegister",
  
  data() {
    return {
      showProfiles: {
        classBiker: "btn-danger",
        classLubricator: "btn-danger",
        biker: true,
        lubricator: true,
      },
      listDocuments: [],
      listCities: [],
      listTypeDocuments: [],
      form: {
        documentType: 0,
        documentNumber: "",
        name: "",
        lastName: "",
        state: 0,
        cityId: 0,
        phone: "",
        email: "",
        birthdate: "",
        pass: "",
        passCon: "",
        check: false,
        checkMail: false,
      },
      errors: {
        documentType: false,
        documentNumber: false,
        name: false,
        lastName: false,
        state: false,
        cityId: false,
        phone: false,
        email: false,
        birthdate: false,
        pass: false,
        passCon: false,
        check: false,
      },
      showCities: true,
      disableLoading: false,
      disableLoadingGoogle: false,
      file: null,
      cantPoints: 0,
    };
  },
  methods: {
    minDate() {
      const now = new Date();
      now.setFullYear(now.getFullYear() - 100);
      return now.toISOString().substr(0, 10);
    },
    maxDate(){
      const now = new Date();
      now.setFullYear(now.getFullYear() - 18);
      return now.toISOString().substr(0, 10);
    },
    getDocuments() {
      axios
        .get("api/files/active/" + 1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.file = res.data.data[0].url;
          }
        })
        .catch((error) => {
          console.log(error.response);
        });
    },
    irCode() {
      let sesion = sessionStorage.getItem("token");
      if (sesion == "" || sesion == null) {
        this.$router.push({ name: "login" });
      } else {
        this.$router.push({ name: "homeUser" });
      }
    },
    getListStates() {
      var app = this;
      axios
        .get("api/getStates")
        .then(function(res) {
          app.listDocuments = res.data.states;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getCities(stateId) {
      var app = this;
      var data = {
        stateId: stateId,
      };
      axios
        .post("api/showCity", data)
        .then(function(res) {
          app.showCities = false;
          app.listCities = res.data.cities;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getTypeDocuments() {
      var app = this;
      axios
        .get("api/documentTypeController")
        .then(function(res) {
          app.listTypeDocuments = res.data.TypeDocument;
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    validform() {
      let app = this;

      if (!app.form.documentType) {
        app.errors.documentType = "El tipo de documento es requerido.";
        return false;
      }
      if (!app.form.documentNumber) {
        app.errors.documentNumber = "El númnero de documento es requerido.";
        return false;
      }
      if (!app.form.name) {
        app.errors.name = "Los nombres son requeridos.";
        return false;
      }
      if (!app.form.lastName) {
        app.errors.lastName = "Los apellidos son requeridos.";
        return false;
      }
      if (!app.form.state) {
        app.errors.state = "El departamento es requerido.";
        return false;
      }
      if (!app.form.cityId) {
        app.errors.cityId = "La ciudad es requerida.";
        return false;
      }
      if (!app.form.phone) {
        app.errors.phone = "El número de teléfono es requerido.";
        return false;
      }
      if (!app.form.email) {
        app.errors.email = "El email es requerido.";
        return false;
      }
      if (!app.form.birthdate) {
        app.errors.birthdate = "La fecha de nacimiento es requerida.";
        return false;
      }
      if (!app.form.pass) {
        app.errors.pass = "La contraseña es requerida.";
        return false;
      }
      if (!app.form.passCon) {
        app.errors.passCon = "La contraseña es requerida.";
        return false;
      }
      if (app.form.passCon != this.form.pass) {
        app.errors.passCon = "Las contraseñas deben ser iguales";
        return false;
      }
      if (!app.form.check) {
        app.errors.check = "Debe aceptar términos y condiciones";
        return false;
      }
      if (
        !app.errors.documentType &&
        !app.errors.documentNumber &&
        !app.errors.name &&
        !app.errors.lastName &&
        !app.errors.state &&
        !app.errors.cityId &&
        !app.errors.phone &&
        !app.errors.email &&
        !app.errors.birthdate &&
        !app.errors.pass &&
        !app.errors.passCon &&
        !app.errors.check &&
        !app.validEmail(app.errors.email) &&
        !app.validPhone(app.errors.phone) &&
        !app.validPassword(app.errors.pass)
      ) {
        return true;
      }
      return false;
    },
    registerUser() {
      if (this.form.checkMail) {
        this.form.checkMail = 1;
      } else {
        this.form.checkMail = 0;
      }

      if (this.validform()) {
        var app = this;
        app.disableLoading = true;
        console.log('app.form ', JSON.stringify(app.form));
        axios
          .post("api/landing/register", app.form)
          .then(function(res) {
            app.disableLoading = false;
            if (res.data.cod == 0) {
              localStorage.setItem('sms', res.data.message);
              app.$router.push({ name: "thankyou", params: { event_origin: "Registro con formulario rápido" } });
            } else if (res.data.ResponseCode === 3) {
              app.$swal({
                icon: "error",
                title: "Oops...",
                text: res.data.ResponseMessage,
                confirmButtonColor: "#dc3545",
              });
            } else {
              app.$swal({
                icon: "error",
                title: "Oops...",
                text: "Ocurrió un error realizando el registro",
                confirmButtonColor: "#dc3545",
              });
            }
          })
          .catch(function() {
            app.disableLoading = false;
            app.$swal({
              icon: "error",
              title: "Oops...",
              text: "Ocurrió un error realizando el registro",
            });
          });
      }
    },
    registerGoogle() {
      this.$gapi.login().then(({ currentUser }) => {
        // console.log('currentUser: ', JSON.stringify(currentUser));
        var profileUser = currentUser.getBasicProfile();
        var profileU = Object.values(profileUser);
        // console.log('profileU: ', JSON.stringify(profileU));
        let id_token = currentUser.getAuthResponse().id_token;
        this.data = {
          name: profileU[2],
          last_name: profileU[3],
          email: profileU[5],
          token: id_token,
          link: this.form.link
        };
        // console.log(JSON.stringify(this.data));
        this.disableLoadingGoogle = true;
        axios
          .post("api/landing/register/google", this.data)
          .then(async res => {
            if (res.data.cod == 0) {
              localStorage.setItem('sms', res.data.message);
              this.$router.push({ name: "thankyou", params: { event_origin: "Registro rápido con Google" } });
            } else {
              this.$swal({
                icon: "info",
                title: "Oops...",
                html: res.data.message,
                confirmButtonText: "OK",
                confirmButtonColor: "#dc3545"
              });
            }
            this.disableLoadingGoogle = false;
          })
          .catch((error) => {
            this.$swal({
              icon: "info",
              title: "Oops...",
              html: error.response.data.message,
              confirmButtonText: "OK",
              confirmButtonColor: "#dc3545",
            });
            this.disableLoadingGoogle = false;
          });
      });
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validPhone(phone) {
      var re = /^[0-9]{7,10}$/;
      return re.test(phone);
    },
    validPassword(pass) {
      var re = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
      return re.test(pass);
    },
    irRedirection(url) {
      if (url != null && url != '') {
        var a = document.createElement('a');
        a.href=url;
        a.click();
      }
    },
    showPass(type){
      if(type == 1){
        let pass = this.$refs.password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass1').addClass('fa-eye');
          $('#pass1').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass1').addClass('fa-eye-slash');
          $('#pass1').removeClass('fa-eye');
        }
      } else {
        let pass = this.$refs.confirm_password;
        if(pass.type == "password"){
          pass.type = "text";
          $('#pass2').addClass('fa-eye');
          $('#pass2').removeClass('fa-eye-slash');
        } else {
          pass.type = "password";
          $('#pass2').addClass('fa-eye-slash');
          $('#pass2').removeClass('fa-eye');
        }
      }
    },
  },
  watch: {
    "form.documentType": function(n) {
      if (n != 0) {
        this.errors.documentType = false;
      } else {
        this.errors.documentType = "El tipo de documento es requerido.";
      }
    },
    "form.documentNumber": function(n) {
      if (n) {
        this.errors.documentNumber = false;
      } else {
        this.errors.documentNumber = "El número de documento es requerido.";
      }
    },
    "form.name": function(n) {
      if (n) {
        this.errors.name = false;
      } else {
        this.errors.name = "Los nombres son requeridos.";
      }
    },
    "form.lastName": function(n) {
      if (n) {
        this.errors.lastName = false;
      } else {
        this.errors.lastName = "Los apellido son requeridos.";
      }
    },
    "form.state": function(n) {
      this.getCities(n);
      if (n == 0) {
        this.errors.state = "El departamento es requerido.";
      } else {
        this.errors.state = false;
      }
    },
    "form.cityId": function(n) {
      if (n != 0) {
        this.errors.cityId = false;
      } else {
        this.errors.cityId = "La ciudad es requerida.";
      }
    },
    "form.phone": function(n) {
      if (!n) {
        this.errors.phone = "El teléfono es requerido.";
      } else if (!this.validPhone(n)) {
        this.errors.phone = "El teléfono es inválido.";
      } else {
        this.errors.phone = false;
      }
    },
    "form.email": function(n) {
      if (!n) {
        this.errors.email = "El email es requerido.";
      } else if (!this.validEmail(n)) {
        this.errors.email = "El email es inválido.";
      } else {
        this.errors.email = false;
      }
    },
    "form.birthdate": function(n) {
      if (n != 0) {
        this.errors.birthdate = false;
      } else {
        this.errors.birthdate = "La fecha de nacimiento es requerida.";
      }
    },
    "form.pass": function(n) {
      if (!n) {
        this.errors.pass = "La contraseña es requerida.";
      } else if (!this.validPassword(n)) {
        this.errors.pass =
          "La contraseña es inválida, debe tener entre 8 a 16 carácteres, al menos un dígito, al menos una minúscula y al menos una mayúscula. Puede tener otros símbolos.";
      } else {
        this.errors.pass = false;
      }
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.passCon": function() {
      if (this.form.passCon == this.form.pass) {
        this.errors.passCon = false;
      } else {
        this.errors.passCon = "Las contraseñas deben ser iguales";
      }
    },
    "form.check": function() {
      if (!this.form.check) {
        this.errors.check = "Debe aceptar términos y condiciones";
      } else {
        this.errors.check = false;
      }
    },
  },
  eforeDestroy() {
    // Eliminar el listener de resize antes de destruir el componente
    window.removeEventListener('resize', this.getImage);
  },
  mounted() {
    this.getTypeDocuments();
    this.getDocuments();
    this.getListStates();
    this.cantPoints = localStorage.getItem("cantPoints");
    var url = localStorage.getItem('link');
    var url_2 = this.$route.name;

    if(url != null){
      if(url.includes("register-data")){
        this.form.link = url;
      } else {
        this.form.link = url_2;
      }
    } else {
      this.form.link = url_2;
    }
  },
};
</script>

<style scoped>
.content_register {
  padding-left: 5%;
  padding-top: 10%;
  padding-bottom: 10%;
  height: 100%;
}
.table-register {
  margin-left: 10%;
}
.btn-danger{
  float: left;
}
.club {
  font-size: 30px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.white_line{
  border: 2px solid white;
  margin: auto;
}
.content_title{
  text-align: left;
}
.obten{
  font-size: 50px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
}
.points{
  font-size: 50px;
  font-family: "Gotham-UltraItalic", sans-serif;
  text-align: left;
  color: yellow;
}
.description{
  font-size: 20px;
  text-align: left;
  font-family: "GothamBoldItalic", sans-serif;
}
.description_mobile{
  display: none !important;
  font-family: "GothamBoldItalic", sans-serif;
}
.info_btn_google{
  font-size: 20px;
  margin: 30px 0px 30px 0px;
  font-family: "GothamBookItalic", sans-serif;
  text-align: left;
}
.button_google{
  max-width: 30%;
  margin: auto auto auto 0px;
}
.complet_your_form{
  font-size: 20px;
  text-align: center;
  font-family: "GothamBoldItalic", sans-serif;
}
.password-text {
  font-family: "GothamBoldItalic", sans-serif;
}
#content1-register {
  background-size: cover;
  background-image: url("../../assets/landingRegister/background_landing_register.jpg");
  background-position: center center;
  background-attachment: fixed;
  background-color: "#171717";
}
a.condiciones {
  text-align: left !important;
  cursor: pointer !important;
  color: white;
  border-bottom: 1px solid;
}
.condiciones:hover {
  color: #b3b3b3 !important;
  /* border-bottom: 1px solid; */
}
.color-input {
  font-size: 13px;
  background-color: #ffffff00 !important;
  height: 30px !important;
  color: #fff !important;
  position: relative;
  padding: 0px 15px !important;
}
.color-input:disabled {
  /* opacity: 0 !important; */
  border-color: #676565 !important;
  color: #676565 !important;
}
.is-danger {
  border: solid 2px !important;
  border-color: #1da5df !important;
}
.error-danger {
  text-align: left !important;
  padding-bottom: 17px !important;
  margin-top: -15px !important;
  color: #1da5df !important;
}
.color-input::placeholder {
  color: white !important;
}
.color-option {
  color: black !important;
}
.color-option:active {
  background-color: crimson !important;
}
.small-info {
  text-align: left !important;
  color: #fff !important;
  font-size: 16px !important;
}
.eye_pass{
  position: absolute;
  height: 100%;
  right: 5%;
  padding-top: 4px;
  cursor: pointer;
  z-index: 1000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

@font-face {
  font-family: "Gotham-UltraItalic";
  src: url("./../../assets/font/Gotham-UltraItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBoldItalic";
  src: url("./../../assets/font/GothamBoldItalic.ttf");
  font-display: swap;
}
@font-face {
  font-family: "GothamBookItalic";
  src: url("./../../assets/font/GothamBookItalic.ttf");
  font-display: swap;
}

/* LAPTOP NORMAL */
@media (max-width: 1200px) {
  .color-input {
    padding: 0px 15px !important;
  }
  .content_register {
    height: 100%;
  }
}

/* TABLET */
@media (max-width: 1023px) {
  .content_register {
    height: 100%;
  }
}

/* MOBILE */
@media (max-width: 767px) {
  .p-row {
    padding-bottom: 1% !important;
  }
  .table-register {
    margin-left: 0%;
  }
  .content_register {
    padding-left: 0%;
    padding-top: 50%;
    padding-bottom: 30%;
  }
  .club{
    font-size: 28px;
  }
  .obten{
    font-size: 32px;
    font-family: "Gotham-UltraItalic", sans-serif;
  }
  .points{
    font-size: 32px;
    font-family: "Gotham-UltraItalic", sans-serif;
  }
  .description{
    display: none !important;
  }
  .description_mobile{
    display: block !important;
    font-size: 18px;
    text-align: justify;
  }
  .button_google{
    max-width: 50%;
    margin: auto;
  }
}
</style>
